module.exports = __webpack_public_path__ + "img/evaluation.4e23fe6b.png";